import Filter from '../components/Filter';
import ProductOffer from "../components/ProductOffer";

export default (function (w, d) {
    'use strict';

    function CategoryController() {
        new Filter();
        new ProductOffer(false);
    }

    return CategoryController;
}(window, document));
